export default {"src":"/_next/static/media/fruit.72abc998.svg","height":28,"width":25,"blurWidth":0,"blurHeight":0};